export const addHocs = (component, hocs) => {
  let result = component
  for (const hoc of hocs) {
    result = hoc(result)
  }
  return result
}

export default addHocs
